import { useGroupsContext } from '@fs/zion-tree-groups'
import Subnav from '@fs/zion-tree-subnav-legacy'
import React from 'react'
import SubnavLoading from './SubnavLoading'

export default function SubnavWrapper(): JSX.Element {
  const { loading } = useGroupsContext()
  if (loading) {
    return <SubnavLoading />
  }
  return <Subnav page="person" showHelpOthers />
}
